import React from "react"
import { withFormsy } from "formsy-react"
import types from "prop-types"
import { useSelector } from "react-redux"
import { subscribedToAddOnFeature } from "reduxSlices/addOnFeatureSubscriptionsSlice"
import { AUTHENTICATED_FORMS_FEATURE_NAME } from "utils/addOnFeatureHelpers"
import { ORGANIZATION_ROLES, READABLE_ROLE_NAMES, SUBMITTER_ROLE } from "utils/userRoleHelpers"
import Select from "./Select"

const ROLE_OPTIONS = ORGANIZATION_ROLES.map((role) => (
  { label: READABLE_ROLE_NAMES[role], value: role }
))

const UserRoleSelect = ({
  onChange,
  value = null,
  selectLabel = "select user role",
  ...props
}) => {
  const includeSubmitter = useSelector(subscribedToAddOnFeature(AUTHENTICATED_FORMS_FEATURE_NAME))

  const roleOptions = includeSubmitter
    ? ROLE_OPTIONS
    : ROLE_OPTIONS.filter((roleOption) => roleOption.value !== SUBMITTER_ROLE)

  return (
    <Select
      backspaceDelete={false}
      onChange={onChange}
      options={roleOptions}
      value={value}
      required
      validations={{ isNotBlankString: true }}
      validationErrors={{ isDefaultRequiredValue: "required" }}
      label={selectLabel}
      {...props}
    />
  )
}

UserRoleSelect.propTypes = {
  selectLabel: types.string,
  onChange: types.func.isRequired,
  value: types.string,
}

export const FormsyUserRoleSelect = withFormsy(({ setValue, ...rest }) => (
  <UserRoleSelect {...rest} onChange={setValue} />
))

FormsyUserRoleSelect.displayName = "FormsyUserRoleSelect"

export default UserRoleSelect
